import React from 'react';
import Molten from '@leverege/molten';
import { GlobalState, UI } from '@leverege/ui-redux';
import { Dialogs } from '@leverege/ui-elements';
import SetConfigurationDialog from './SetConfigurationDialog';
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'recovr.fota.SetConfigurationMenu',
  name: 'Set Location Configuration Menu',
  layout: {
    sort: 'zz.fota.configurationRelease',
    sectionName: 'FOTA'
  },
  matches: {
    client: ['GroupScreen'],
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location'
  },
  isPrepared: cxt => GlobalState.get().ui?.deviceSkus?.length > 0,
  prepare: async cxt => {
    const systemId = Molten.getConfig('api/systemId');
    const r4kEnabled = Molten.getConfig('r4kEnabled') === 'true';
    const responseItems = [];
    const rcvResponse = await GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => api.system(systemId).srv('recovr').get('deviceSku'));
    if (rcvResponse?.items) {
      responseItems.push(...rcvResponse.items.map(item => {
        return {
          ...item,
          server: 'recovr'
        };
      }));
    }
    if (r4kEnabled) {
      const kdsResponse = await GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => api.system(systemId).srv('kudelskidevice').get('deviceType'));
      if (kdsResponse?.items) {
        responseItems.push(...kdsResponse.items.map(item => {
          return {
            ...item,
            server: 'kudelskidevice'
          };
        }));
      }
    }
    const uniqueResponseItems = [...new Set(responseItems)];
    uniqueResponseItems.sort((a, b) => a.sku.localeCompare(b.sku));
    return GlobalState.dispatch(UI.multiSet({
      deviceSkus: uniqueResponseItems
    }));
  },
  handles: cxt => cxt?.target?.length > 0 || cxt?.mobile,
  getActions() {
    const {
      deviceSkus
    } = GlobalState.get().ui;
    const actions = getSkuActions(deviceSkus);
    return [{
      type: 'layoutNode',
      name: 'Configuration',
      items: actions
    }];
  }
};
function getSkuActions(deviceSkus) {
  return deviceSkus?.map(deviceSku => {
    const actions = getSetConfigurationAction(deviceSku);
    return {
      handles: cxt => cxt?.target?.length > 0 || cxt?.mobile,
      appearance: () => ({
        name: deviceSku.sku
      }),
      getActions() {
        return [{
          type: 'layoutNode',
          name: deviceSku.sku,
          items: actions
        }];
      }
    };
  });
}
function getSetConfigurationAction(deviceSku) {
  return [{
    handles: cxt => cxt?.target?.length > 0 || cxt?.mobile,
    appearance: () => ({
      name: 'Set Configuration'
    }),
    perform: props => {
      const {
        context: {
          target = [],
          clientProps: {
            dispatch
          }
        }
      } = props;
      Dialogs.show({
        component: props => {
          return /*#__PURE__*/_jsx(SetConfigurationDialog, {
            ...props,
            dispatch: dispatch,
            locationIds: target.map(location => location.id),
            sku: deviceSku.sku,
            server: deviceSku.server
          });
        }
      });
    }
  }];
}